export default "__VITE_ASSET__D0muTkx1__"